import { CreateFormatFolderParams } from "@common/actions/formats";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";
import { HttpSuccessDto } from "@common/dto/http";
import { clientTransformed } from "@common/utils/rest";

const URL_PREFIX = "api/folders";

const getUrl = (path: string) => {
  return `${URL_PREFIX}/${path}`;
};

export const getQueryFormatFolders = (): Promise<
  Array<FolderPrimaryListDto>
> => {
  return clientTransformed({
    path: getUrl("formats/invites"),
    method: "GET",
  }).then((response: HttpSuccessDto<Array<FolderPrimaryListDto>>) => {
    return response.entity;
  });
};

export const saveQueryFormatFolder = (
  params: CreateFormatFolderParams
): Promise<void> => {
  const { ...restParams } = params;
  return clientTransformed({
    path: getUrl(`formats/invites`),
    method: "POST",
    params: restParams,
  }).then((response: HttpSuccessDto<Array<any>>) => {
    return response.entity;
  });
};

export const deleteQueryFormatFolder = (params: {
  folderId: number;
}): Promise<void> => {
  return clientTransformed({
    path: getUrl(`formats/invites/delete?&folderId=${params.folderId}`),
    method: "POST",
  }).then((response: HttpSuccessDto<void>) => {
    return response.entity;
  });
};
